// Mirrors impire-sdk-go/toolkit/wire.go (branch 08-toolkits) through the
// library's toolkit and linking modules, which carry the same names — the
// signature a toolkit advertises, the three scopes and schemes, the link and
// the setup a client derives the experience from, the credential paths, the
// exchange verb's bodies and the contract's codes
// (02-DESIGN/08-toolkits/01-the-toolkit-contract.md § the signature;
// 03-linking.md § the flow, § the namespace). Re-exported here so that a
// surface imports one wire module per Go file. The console calls no tool.

import { linking, toolkit, vault } from "@impire-io/sdk";

export const SERVICE = toolkit.SERVICE;

export const Scope = toolkit.Scope;
export type Scope = toolkit.Scope;
export const Scheme = toolkit.Scheme;
export type Scheme = toolkit.Scheme;
export const ClientType = toolkit.ClientType;
export type ClientType = toolkit.ClientType;

export type Toolkit = toolkit.Toolkit;
export type Tool = toolkit.Tool;
export type Link = toolkit.Link;
export type Setup = toolkit.Setup;
export type TokenRecord = toolkit.TokenRecord;

export const Code = toolkit.Code;

export const validName = toolkit.validName;
export const validScope = toolkit.validScope;
export const validScheme = toolkit.validScheme;
export const compatible = toolkit.compatible;
export const find = toolkit.find;

/** The paths: a person's own for a toolkit, the tenant's shared credential, a confidential client's secret. */
export const personCredentialPath = toolkit.personCredentialPath;
export const credentialPath = toolkit.credentialPath;
export const clientSecretPath = toolkit.clientSecretPath;
export const PERSON_TOOLKIT_SEGMENT = toolkit.PERSON_TOOLKIT_SEGMENT;

/**
 * personToolkitPrefix is where a person's toolkit credentials live,
 * `person.<principal>.toolkit`: listed to read linked or configured without
 * revealing a value (03-linking.md § discovering what needs linking).
 */
export function personToolkitPrefix(principal: string): string {
  return vault.personPath(principal, toolkit.PERSON_TOOLKIT_SEGMENT);
}

/** TOKEN_SETUP_SCHEMA is the setup schema of a `token` scheme whose record is one pasted bearer or API key. */
export const TOKEN_SETUP_SCHEMA = toolkit.TOKEN_SETUP_SCHEMA;

/** The linking flow: the PKCE pair, the state, the authorization URL, the exchanges, the person's path, and what is linked. */
export const pkce = linking.pkce;
export const newState = linking.newState;
export const authorizationUrl = linking.authorizationUrl;
export const exchangePublic = linking.exchangePublic;
export const linkPath = linking.credentialPath;
export const isLinked = linking.isLinked;
export const LinkError = linking.LinkError;
export type Exchange = linking.Exchange;
